import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./styles/commande.css";
import "./styles/theme.css";

import { ThemeProvider } from "./contexts/ThemeContext";
import ProtectedRoute from "./components/Common/ProtectedRoute";
import HomePage from "./pages/HomePage";
import FAQPage from "./pages/FAQPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import CompleteProfilePage from "./pages/CompleteProfilePage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import AccountPage from "./pages/AccountPage";
import PreferencesPage from "./pages/PreferencesPage";
import LoyaltyPage from "./pages/LoyaltyPage";
import OrderPage from "./pages/OrderPage";
import OrderHistoryPage from "./pages/OrderHistoryPage";
import OrderDetailPage from "./pages/OrderDetailPage";
import ConfirmationPage from "./pages/ConfirmationPage";
import PaymentPage from "./pages/PaymentPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentFailedPage from "./pages/PaymentFailedPage";
import CGUPage from "./pages/CGUPage";
import CGVPage from "./pages/CGVPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import PolitiqueConfidentialitePage from "./pages/PolitiqueConfidentialitePage";
import NPSThankYouPage from "./pages/NPSThankYouPage";
import NPSErrorPage from "./pages/NPSErrorPage";

function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <ThemeProvider>
        <Router>
          <ToastContainer position="top-right" autoClose={3000} />
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route path="/faq" component={FAQPage} />
            <Route path="/about" component={AboutPage} />
            <Route path="/contact" component={ContactPage} />
            <Route path="/cgu" component={CGUPage} />
            <Route path="/cgv" component={CGVPage} />
            <Route path="/mentions-legales" component={MentionsLegalesPage} />
            <Route path="/politique" component={PolitiqueConfidentialitePage} />
            <Route path="/login" component={LoginPage} />
            <Route path="/register" component={RegisterPage} />
            <Route path="/complete-profile" component={CompleteProfilePage} />
            <Route path="/forgot-password" component={ForgotPasswordPage} />
            <Route path="/change-password" component={ChangePasswordPage} />

            {/* Public NPS Routes */}
            <Route path="/nps/error" component={NPSErrorPage} />
            <Route path="/nps/:token/rate/:score" component={NPSThankYouPage} />

            <ProtectedRoute path="/account" component={AccountPage} />
            <ProtectedRoute path="/preferences" component={PreferencesPage} />
            {/* HIDDEN - Loyalty program disabled */}
            {/* <ProtectedRoute path="/loyalty" component={LoyaltyPage} /> */}
            <ProtectedRoute path="/commande" component={OrderPage} />
            <ProtectedRoute path="/historique/:orderId" component={OrderDetailPage} />
            <ProtectedRoute exact path="/historique" component={OrderHistoryPage} />
            <ProtectedRoute path="/payment" component={PaymentPage} />
            <ProtectedRoute path="/payment-success" component={PaymentSuccessPage} />
            <ProtectedRoute path="/payment-failed" component={PaymentFailedPage} />
            <ProtectedRoute path="/confirmation" component={ConfirmationPage} />
          </Switch>
        </Router>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
